// extracted by css-extract-rspack-plugin
export default {"row":"JgccGJKO","captureInput":"IAykVKFn","box":"T4kknA0L","accent":"cBRAQOn7","caret":"W8Y0AIJo","otp-caret-blink":"dh21otL8"};